import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CampaignLayer from "../components/CampaignLayer";


const CampaignList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Campaign List" />


        {/* CampaignLayer */}
        <CampaignLayer />

      </MasterLayout>
    </>
  )
};

export default CampaignList;
